export const reportBillingState = {
  billableDate: null,
  originalBillableDate: null,
  isBillingDateSubmitting: false,
};
